import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useNavigateWithQuery = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback((newPath: string) => {
        const currentSearchParams = new URLSearchParams(location.search);

        // Check if newPath already contains a query string
        const [path, newQueryString] = newPath.split('?');

        // If newPath has query parameters, add them to our searchParams object
        if (newQueryString) {
            const newSearchParams = new URLSearchParams(newQueryString);
            // Merge new search params with current search params
            newSearchParams.forEach((value, key) => {
                currentSearchParams.set(key, value);
            });
        }

        const queryString = currentSearchParams.toString();
        const newUrl = queryString ? `${path}?${queryString}` : path;
        navigate(newUrl);
    }, [location.search, navigate]);
};

export default useNavigateWithQuery;
